import { render, staticRenderFns } from "./GoldNews.vue?vue&type=template&id=023444a9&"
import script from "./GoldNews.vue?vue&type=script&lang=js&"
export * from "./GoldNews.vue?vue&type=script&lang=js&"
import style0 from "./GoldNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports